export const messages = {
  page: {
    title: {
      id: 'dataProtection.Page.Title',
      defaultMessage: 'Personal Data & Privacy',
    },
    subTitle: {
      id: 'dataProtection.Page.SubTitle',
      defaultMessage: `Use this page to download your activity log or your personal data. 
        Refer to the Privacy Statement for more information on your data privacy.`,
    },
  },
};
